import * as Auth0 from '@auth0/auth0-react'
import type { FC, PropsWithChildren } from 'react'

import { Auth0Effects } from './Auth0Effects'
import { useNavigate } from 'react-router'
import { toSafeInternalPath } from '~/shared/lib/safeInternalPath'
import { asString } from '~/shared/lib/guards'

export const Auth0Provider: FC<PropsWithChildren> = ({ children }) => {
  const navigate = useNavigate()
  const onRedirectCallback = (appState?: Auth0.AppState) => {
    const basePath = window.location.pathname.replace(/\/$/, '')

    // Re-checked at the sink, not just where `?next=` is read: this is the call
    // that navigates a user who has just authenticated, so it is the one that
    // must not be able to leave the origin.
    void navigate(toSafeInternalPath(asString(appState?.next) || `${basePath}/inbox`))
  }

  return (
    <Auth0.Auth0Provider
      clientId={import.meta.env.VITE_AUTH0_CLIENT_ID ?? ''}
      domain={import.meta.env.VITE_AUTH0_TENANT_URL ?? ''}
      authorizationParams={{
        redirect_uri: window.location.origin,
      }}
      onRedirectCallback={onRedirectCallback}
    >
      <Auth0Effects>{children}</Auth0Effects>
    </Auth0.Auth0Provider>
  )
}
